
export type NotificationListResponseNotificationsItemStatus = {
  isRead: boolean;
};
